import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * Standard page header used by all main pages.
 *
 * Props:
 *   title: string (required)
 *   subtitle?: string
 *   actions?: ReactNode (right-aligned buttons)
 */
export default function PageHeader({ title, subtitle, actions }) {
  return (
    <Box sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      mb: 3,
      gap: 2,
      flexWrap: 'wrap',
    }}>
      <Box sx={{ minWidth: 0 }}>
        <Typography variant="h5" sx={{ fontWeight: 600, letterSpacing: '-0.01em' }}>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            {subtitle}
          </Typography>
        )}
      </Box>
      {actions && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexShrink: 0 }}>
          {actions}
        </Box>
      )}
    </Box>
  );
}
